// extracted by mini-css-extract-plugin
export default {"main":"DDprn6","container":"_SIKtI"};